import React from "react";

const Support: React.FC = () => {
  return (
    <div className = "home-container">
    <div className="container">
      <h1>EngiCalc - User Support</h1>

      <div className="faq-section">
        <h2>🐞 What if I find a bug?</h2>
        <p>Please contact us at <strong>Engicalc-devteam-access@outlook.com</strong>.</p>

      </div>
    </div>
  </div>
  );
};

export default Support;
